import {
  TeContainer,
  TeContainerSlim,
  TeSearch,
  TeText,
  TeButtonMinimal,
  TeRadio,
  TeRadioGroup,
} from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  visibleItemsText?: string;
  visibleItemsCount?: number;
  searchValue?: string;
  setSearchValue?: (value: string) => void;
  searchPlaceholder?: string;
  onMarkAllAsRead?: () => void;
  markAllAsReadLoading?: boolean;
  markAllAsReadDisabled?: boolean;
  onUnreadFilter?: (value: 'all' | 'unread') => void;
  showUnreadFilter?: boolean;
  unreadCount?: number;
  selectedFilter?: 'all' | 'unread';
}

function NotificationsHeader({
  title,
  visibleItemsCount,
  searchValue,
  setSearchValue,
  searchPlaceholder,
  onMarkAllAsRead,
  markAllAsReadLoading,
  markAllAsReadDisabled,
  onUnreadFilter,
  showUnreadFilter = false,
  selectedFilter = 'all',
}: Props) {
  const { t } = useTranslation('notifications');

  return (
    <TeContainer
      alignItems="center"
      justifyContent="space-between"
      backgroundColor="background.primary"
      borderRadius={4}
      fill
      height="xl2"
      padding="s"
    >
      <TeContainerSlim alignItems="center" gap="xs" justifyContent="flex-start">
        <TeText size={20} weight={700}>
          {title}
        </TeText>
        {visibleItemsCount !== undefined && visibleItemsCount !== 0 && (
          <TeContainerSlim gap="xs3">
            <TeText size={14} color="text.secondary">
              (
            </TeText>
            <TeText size={14} color="text.secondary">
              {visibleItemsCount}
            </TeText>
            <TeText size={14} color="text.secondary">
              )
            </TeText>
          </TeContainerSlim>
        )}
      </TeContainerSlim>

      <TeContainerSlim alignItems="center" gap="s" justifyContent="flex-end">
        {/* Filter and action buttons */}
        <TeContainerSlim gap="xs" alignItems="center">
          {showUnreadFilter && (
            <TeRadioGroup>
              <TeRadio
                name="unreadFilter"
                value="all"
                label={'All'}
                techange={() => onUnreadFilter?.('all')}
                checked={selectedFilter === 'all'}
              />
              <TeRadio
                name="unreadFilter"
                value="unread"
                label={t('unread')}
                techange={() => onUnreadFilter?.('unread')}
                checked={selectedFilter === 'unread'}
              />
            </TeRadioGroup>
          )}
          {onMarkAllAsRead && (
            <TeButtonMinimal
              text={t('markAllAsRead')}
              size="s"
              loading={markAllAsReadLoading}
              disabled={markAllAsReadDisabled}
              teclick={onMarkAllAsRead}
            />
          )}
        </TeContainerSlim>

        {/* Search */}
        {setSearchValue && (
          <TeSearch
            size="s"
            placeholder={searchPlaceholder}
            value={searchValue}
            techange={(e) => setSearchValue(e.target.value)}
            clearable={!!searchValue}
          />
        )}
      </TeContainerSlim>
    </TeContainer>
  );
}

export default NotificationsHeader;
